<template>
  <div>
  <el-dialog v-loading="loading.dialog" class="developing_model_dialog" top="5vh" center
             title="发布申请" width="90%" :append-to-body="true" :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form  size="mini" ref="form" :rules="rules" :model="form">
    <el-form-item label="" >
    <el-table :data="deplyList" border style="width: 100%;margin-top: -10px;">
     <el-table-column fixed prop="taskName" label="开发任务" min-width="150" :show-overflow-tooltip="true">
     </el-table-column>
      <el-table-column prop="testTaskName" label="测试任务名称" width="120" :show-overflow-tooltip="true">
      </el-table-column>
<!--     <el-table-column prop="title" label="主域名" width="120" :show-overflow-tooltip="true">
     </el-table-column>-->
     <el-table-column prop="module" label="系统" width="120" :show-overflow-tooltip="true">
     </el-table-column>
     <el-table-column prop="devleloper" label="开发人员" width="120" :show-overflow-tooltip="true">
       <template slot-scope="scope">
         <span>{{scope.row.devleloper.nameZh ? scope.row.devleloper.nameZh: ''}}</span>
       </template>
     </el-table-column>
     <el-table-column prop="tester" label="测试人员" width="120" :show-overflow-tooltip="true">
       <template slot-scope="scope">
         <span>{{scope.row.tester.nameZh ? scope.row.tester.nameZh : ''}}</span>
       </template>
     </el-table-column>
     <el-table-column prop="deployBranch" label="上线分支" width="80" :show-overflow-tooltip="true">
     </el-table-column>
     <el-table-column prop="devBranch" label="开发分支" width="120" :show-overflow-tooltip="true">
     </el-table-column>
     <el-table-column prop="needSqlDeploy" label="是否sql部署" width="120" :show-overflow-tooltip="true">
       <template slot-scope="scope">
         <span>{{scope.row.needSqlDeploy === 0?'否':'是'}}</span>
       </template>
     </el-table-column>
     <el-table-column prop="needDeploy" label="是否代码发布" width="120" :show-overflow-tooltip="true">
       <template slot-scope="scope">
         <span>{{scope.row.needDeploy === 0?'否':'是'}}</span>
       </template>
     </el-table-column>
     <el-table-column prop="title" label="发布窗口" width="200">
       <template slot-scope="scope">
         <div>
         <el-date-picker style="width: 180px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="scope.row.deployApplyTime" type="datetime" placeholder="请选择时间"
                         :picker-options="pickerOptions_plt" :disabled="true"/>
         </div>
       </template>
     </el-table-column>
   </el-table>
    </el-form-item>
      <el-form-item label="发布请示证明" prop="pdt_leader_proof" style="margin-top:40px;">
        <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
                   :on-preview="handlePreview" :before-remove="beforeRemove" multiple :limit="3" :on-success="handleSuccess"
                   :on-remove="handleRemove" :file-list="fileList">
          <el-button size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    <!--  #endregion -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.toRelease" @click="submitApi()">提交发布申请</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
  </div>
</template>
<script>
import {
  getDevOpsSpaceDeployApplyTaskListApi,
  postDevOpsSpaceSubmitDemandApi
} from "@/server/tops/devOps";

import { mapState } from "vuex";
export default {
  components: {},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
      },
      formLabelWidth: "135px",
      dialog: {
      },
      loading: {
        toRelease: false,
      },
      fileList: [],
      deplyList: [],
      module_needsql:{},
    };
  },
  async created() {
  if(this.formInfo.id) this.getDeployApplyTaskListApi(this.formInfo.id);
  },
  computed: {
    ...mapState({
      progressBar: (state) => state.devOps.PROGRESSSBAR,
      allSelect: (state) => state.devOps.ALLSELECT,
      webSocket: (state) => state.devOps.WEBSOCKET
    })
  },
  methods: {
    getDeployApplyTaskListApi(id){
      getDevOpsSpaceDeployApplyTaskListApi({demandId: id}).then((res)=>{
       this.deplyList = this.formatTableData(res.data);
      })
    },
    // 格式化数据
    formatTableData(data) {
      let arr = []
      let module_needsql = {}
      data.forEach(o => {
        if(o.needSqlDeploy == 1){
          module_needsql[o.module] = o.needSqlDeploy;
        }
      })
      this.module_needsql = module_needsql;
      data.forEach(o => {
          const obj = { ...o, deployApplyTime: this.timeFormat(o)};
          arr.push(obj)

      })
      return arr;
    },
    timeFormat(o = {}) {
      let dateTime = new Date()
      // 获取年份
      let Y = dateTime.getFullYear() + '-'
      //获取当前年的月份 月份要 + 1 （0代表1月）date.getMonth() + 1
      let M = dateTime.getMonth() + 1 < 10 ? '0' + (dateTime.getMonth() + 1) + '-' : (dateTime.getMonth() + 1) +'-'
      //获取当前日（1 - 31）
      let D = dateTime.getDate() < 10 ? '0' + (dateTime.getDate()) + ' ' : (dateTime.getDate()) + ' '
      // if((o.module == 'odoo' || o.module == 'odoos' || o.module == 'mall') && this.module_needsql[o.module]){
      //   return (Y + M + D + "19:00:00")
      // }
      return (Y + M + D + "18:00:00")
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    submitApi(){
      const pdt_leader_proof = JSON.stringify(this.fileList);
      let msg = '是否确认发布?';
      const currentHour = new Date().getHours();
      if(currentHour >= 18 && currentHour < 24){
        msg = '已错过今天统一发布时间，请线下单独联系运维发布,是否确认发布?';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          this.$set(this.loading, 'toRelease', true)
          let params =  {id: this.formInfo.id,type:5,deployProof:pdt_leader_proof,deployApplyList:JSON.stringify(this.deplyList)};
          await postDevOpsSpaceSubmitDemandApi(params).then((result)=>{
            if(result.status === 'success'){
              this.$notify({
                message: result.message || '提交发布申请成功',
                type: "success",
              })
              setTimeout(() => {
                this.handleClose()
              }, 500)
            }else{
              this.$notify({
                message: result.message || "提交失败",
                type: "error",
              })

              this.handleClose()
            }
          });
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.submitReviewed = false;
        }
      })
      console.log(this.fileList);
      console.log(2222222);
    },
  },
};
</script>
<style lang="scss">
.developing_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.developing_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
</style>
